export const APP_FILE_QUOTE_CONFIG_LIST = "/settings/quote-config";
export const APP_FILE_QUOTE_CONFIG_COVERAGE = "/settings/quote-config/default-coverage";
export const APP_FILE_QUOTE_CONFIG_REMARKS = "/settings/quote-config/default-remarks";
